import React, { useEffect } from 'react';
import './Steps.scss';
import { safeHtml } from '../../../../services/helpers';

export default function Steps({ content }) {

    useEffect(() => {
    content.Étapes.forEach((step, index) => {
        const style = document.createElement('style');
        const stepRightPartClass = `workshop-steps__step_right-part-${index}`;
        const stepRightPart = document.querySelector(`.${stepRightPartClass}`);

        if (!stepRightPart) return; // sécurité : si l'élément n'existe pas

        const lists = stepRightPart.querySelectorAll('div > ul');
        if (lists.length === 0) return; // aucune liste présente

        const lastList = lists[lists.length - 1];
        if (!lastList) return; // sécurité supplémentaire

        const lastListItems = lastList.querySelectorAll('li');
        if (!lastListItems || lastListItems.length === 0) return;

        lastList.classList.add('last-list');
        const className = `last-list-item-${index}`;
        lastListItems.forEach((item) => {
            item.classList.add('last-list-item');
            item.classList.add(className);
        });

        if (step.CouleurTexte2 === '#FFFFFF' || step.CouleurTexte2 === '#ffffff') {
            style.innerHTML = `
                .${className}::marker {
                    content: url("/assets/arrow_playfair_white.svg") " ";
                    vertical-align: bottom;
                    color: ${step.CouleurTexte1};
                }
            `;
        } else {
            style.innerHTML = `
                .${className}::marker {
                    content: url("/assets/arrow_playfair.svg") " ";
                    vertical-align: bottom;
                    color: ${step.CouleurTexte1};
                }
            `;
        }

        document.head.appendChild(style);
    });
}, [content.Étapes]);

    /* useEffect(() => {
        content.Étapes.forEach((step, index) => {
            const style = document.createElement('style');
            const stepRightPartClass = `workshop-steps__step_right-part-${index}`;
            const stepRightPart = document.querySelector(`.${stepRightPartClass}`);
            const lists = stepRightPart.querySelectorAll('div > ul');
            const lastList = lists[lists.length - 1];

            const lastListItems = lastList.querySelectorAll('li')

            if (lastListItems) {
                lastList.classList.add('last-list')
                const className = `last-list-item-${index}`;
                lastListItems.forEach((item) => {
                    item.classList.add('last-list-item');
                    item.classList.add(className);
                })

                if (step.CouleurTexte2 === '#FFFFFF' || step.CouleurTexte2 === '#ffffff') {
                    style.innerHTML = `
                        .${className}::marker {
                            content: url("/assets/arrow_playfair_white.svg") " ";
                            vertical-align: bottom;
                            color: ${step.CouleurTexte1};
                        }
                    `;
                } else {
                    style.innerHTML = `
                        .${className}::marker {
                            content: url("/assets/arrow_playfair.svg") " ";
                            vertical-align: bottom;

                            color: ${step.CouleurTexte1};
                        }
                    `;
                }
                document.head.appendChild(style);
            }
        });
        
        
        
    }, [content.Étapes]); */
    
    
    return (
        <div className='workshop-steps'>
            <h2>{content.Titre}</h2>
            <ul className='workshop-steps__steps_list'>
                {
                    content.Étapes.map((step, index) => (
                        <li
                            key={step.id}
                            className='workshop-steps__step_item'
                        >
                            <div
                                className='workshop-steps__step_left-part'
                                style={{
                                    backgroundColor: step.CouleurArrièrePlan1,
                                    color: step.CouleurTexte1
                                }}
                            >
                                <h3>{step.TitreÉtape.toUpperCase()}</h3>
                                <p className='workshop-steps__step_subtitle'>
                                    {step.ObjectifÉtape}
                                </p>
                            </div>
                            <div
                                className={'workshop-steps__step_right-part workshop-steps__step_right-part-' + index}
                                style={{
                                    backgroundColor: step.CouleurArrièrePlan2,
                                    color: step.CouleurTexte2
                                }}
                            >
                                <div className="" dangerouslySetInnerHTML={safeHtml(step.ContenuÉtape)} />
                            </div>
                        </li>

                    ))
                }
            </ul>
        </div>
    )
}